// extracted by mini-css-extract-plugin
module.exports = {"tableStatus":"tableStatusShippings_tableStatus__35A3w","hoverSign":"tableStatusShippings_hoverSign__3qorn","centered":"tableStatusShippings_centered__32Lrz"};